import {styled} from '@mui/material/styles';

interface IFrameProps {
  styles?: React.CSSProperties;
}

export const StyledIFrame = styled('iframe')(({styles}: IFrameProps) => ({
  '&.iframeCarousel': {
    width: '100%',
    backgroundColor: 'transparent',
    border: 'none',
    minHeight: '520px',
    visibility: 'visible',
    overflowY: 'auto',
    overflowX: 'hidden',
    ...styles
  }
}));
